import { render } from "./ViewInfoFooter.vue?vue&type=template&id=3ba56f63&ts=true"
import script from "./ViewInfoFooter.vue?vue&type=script&lang=ts"
export * from "./ViewInfoFooter.vue?vue&type=script&lang=ts"

import "./ViewInfoFooter.vue?vue&type=style&index=0&id=3ba56f63&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__